  /**
   * Generates a URL to view the Purchase Order report on the SSRS reporting server.
   *
   * @param {number} poNumber - The purchase order number to include in the report URL.
   * @returns {string} The generated PO report URL.
   *
   * This URL links directly to the PO report, allowing users to view shipment details.
   * The URL is populated within the log form for a given PO, as well as in the generated emails on log submission.
   */

export function getPoReportUrl(poNumber: string): string {
    return `https://ssrs/ReportServer/Pages/ReportViewer.aspx?%2fMMFS%2fMM%20Job%20Cost%2fPurchase%20Order&PoNumber=${poNumber}&rs:Command%20=%20Render`;
  }